export default __webpack_public_path__ + "static/media/IntroContentPhone.db7c4d05.png";